import styled from "styled-components"

export default function InstructionalVideosView(props){
    return(
        <StyleInstructionalVideosView>
            <div className="container" style={{textAlign: 'center'}}>
                <h2 style={{marginTop: '10rem'}}>Videos Instructivos para Solución de Piletas</h2>
                <div className="row">
                    <div className="col-6">
                        <div className="containerVideos">
                            <div className="card" style={{width: "100%"}}>
                                <div className="card-body">
                                    <div className="videoContainer">
                                        <iframe
                                            title="Video Home"
                                            src={
                                                "https://player.vimeo.com/video/829485591?controls=1&autopause=false&autoplay=0&loop=1&title=0&byline=0&portrait=0&muted=1"
                                            }
                                            frameBorder="0"
                                            allow="fullscreen; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>

                                    <p className="card-text">Texto de cada video Institucional de la solución piletas</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="containerVideos">
                            <div className="card" style={{width: "100%"}}>
                                <div className="card-body">
                                    <div className="videoContainer">
                                        <iframe
                                            title="Video Home"
                                            src={
                                                "https://player.vimeo.com/video/829485591?controls=1&autopause=false&autoplay=0&loop=1&title=0&byline=0&portrait=0&muted=1"
                                            }
                                            frameBorder="0"
                                            allow="fullscreen; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                    <p className="card-text">Texto de cada video Institucional de la solución piletas</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6">
                        <div className="containerVideos">
                            <div className="card" style={{width: "100%"}}>
                                <div className="card-body">
                                    <div className="video">
                                    </div>
                                    <p className="card-text">Texto de cada video Institucional de la solución piletas</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="containerVideos">
                            <div className="card" style={{width: "100%"}}>
                                <div className="card-body">
                                    <div className="video">
                                    </div>
                                    <p className="card-text">Texto de cada video Institucional de la solución piletas</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </StyleInstructionalVideosView>
    )
}

const StyleInstructionalVideosView = styled.div`
    margin-top: var(--alturaNavBar);
    .containerVideos{
        width:100%;
        padding: 3rem 0rem;
    }
    .video {
        width: 100%;
        background-color: darkgray;
        height: 20rem;
    }
    
    .card-body {
        padding: 0rem;
    }

    .card-text {
        padding: 1.5rem;
    }

    .videoContainer {
        position: relative;
        width: 100%;
        padding-top: 42%; /* Relación de aspecto 16:9 */
        height: 0 !important;
        overflow: hidden;
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
`